import { moment, dateDuration, dayFormatType } from 'common/helpers/day';
import { useTranslation } from 'react-i18next';

export const APITOKEN_TIME = '2023-02-14';

export const DEPOSITE_TIME = '2023-02-14';

export const COUNTEROFFER_TIME = '2023-02-15';

export const handleTimeDuration = start => {
  const { t } = useTranslation();
  const duration = dateDuration(start, new Date());

  if (duration?._isValid) {
    if (duration?._data?.days > 0 || duration?._data?.months > 0 || duration?._data?.years > 0)
      return moment(start).format(dayFormatType.UKFORMAT);

    if (duration?._data?.hours > 0)
      return t('landlord.new_dashboard.broadcast.hours', {
        postProcess: 'interval',
        count: duration?._data?.hours,
      });

    if (duration?._data?.minutes > 1)
      return t('landlord.new_dashboard.broadcast.mins', {
        postProcess: 'interval',
        count: duration?._data?.minutes,
      });

    if (duration?._data?.seconds > 0 || duration?._data?.milliseconds >= 0)
      return t('landlord.new_dashboard.broadcast.mins', {
        postProcess: 'interval',
        count: 1,
      });
  } else {
    return moment(start).format(dayFormatType.UKFORMAT);
  }
};
